import client from "@/api/client.js";
import store from "@/store";

export default {
    methods: {
        async getAddressFromPosition(payload) {
            //todo: client validation
            var meta = {
                clientApiMethod: "getAddressFromPosition",
                input: payload
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/AddressFromLngLat`, {
                params: payload,
                meta: meta
            });
            return response.data;
        },
        async getCoordinateFromAddress(payload) {
            //todo: client validation
            var meta = {
                clientApiMethod: "CoordinateFromAddress",
                input: payload
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/CoordinateFromAddress`, {
                params: payload,
                meta: meta
            });
            return response.data;
        },
        async getRoutePlan(routeRequestDto) {
            //todo: client validation
            var meta = {
                clientApiMethod: "getRoutePlan",
                input: routeRequestDto
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/RoutePlan`, {
                params: routeRequestDto,
                meta: meta
            });
            return response.data;
        },
        async searchAddress(address) {
            //todo: client validation
            var meta = {
                clientApiMethod: "searchAddress",
                input: address
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/SearchAddresses`, {
                params: { address: address },
                meta: meta
            });
            return response.data;
        },
        async getJobLocations(jobIds) {
            //todo: client validation
            var meta = {
                clientApiMethod: "getJobLocations",
                input: jobIds
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/JobLocation`, {
                params: { jobId: jobIds },
                meta: meta
            });
            return response.data;
        },
        async getRouteData(userId, date) {
            var meta = {
                clientApiMethod: "getRouteData",
                input: {userId, date}
            };
            var response = await client().get(`${store.state.apiRouteRoot}maps/RoutePlan`, {
                params: { userId, date },
                meta: meta
            });
            return response.data;
        }
    }
};
